import React, { useState, useRef, useEffect } from "react";

import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import swal from 'sweetalert'
import Axios from "axios";
import Config from "../../config.js"
import Typography from '@material-ui/core/Typography';

const CodeEditor = React.forwardRef((props, ref) => {
    const {
        questionId,
        buttonEnable,
        onClickCallBack,
        ...rest
    } = props;
    useEffect(() => {
    });

    const [sendEnable, setSendEnable] = useState(buttonEnable)
    const [description, setDescription] = useState("")
    const [git, setGit] = useState("")
    function validURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }
    useEffect(() => {
        setSendEnable(buttonEnable);
    }, [buttonEnable]);
    function handleShowValue() {
        if (validURL(git) && git.startsWith("http://git.sharifcamp.ir/")) {
            setSendEnable(false);
            Axios.post(Config.api + "ICTChallenge/Answer", {
                questionId: questionId,
                description: description,
                git: git
            },
                {
                    headers: {
                        apikey: Config.apikey,
                        Authorization: "Bearer " + localStorage.getItem('token')

                    }
                }).then(async (result) => {
                    setSendEnable(true);
                    swal("با موفقیت انجام شد.");
                    setGit("")
                    setDescription("")
                    onClickCallBack();
                }).catch((err) => {
                    if (err && err.response && err.response.status && err.response.status === 401) {
                        localStorage.removeItem('token');
                        props.history.push("/SignIn");
                    }
                    else if (err && err.response && err.response.status && err.response.status === 422)
                        swal("اطلاعات ارسالی نادرست است.");
                    else if (err && err.response && err.response.status && err.response.status === 404) {
                        swal("هم اکنون مسابقه ای در جریان نیست.");
                        //props.history.push("/ICTChallenge");
                    }
                    else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr) {
                        swal(err.response.data.message.pr);
                    }
                    else swal("خطایی رخ داده است.")
                    setSendEnable(true);

                })

        } else {
            return swal("آدرس اینترنتی نادرست است");
        }

    }
    const handleTextBoxChangeDescription = (event) => {
        setDescription(event.target.value)

    };
    const handleTextBoxChangeGit = (event) => {
        setGit(event.target.value)

    };

    const select = {
        textAlign: 'right',
        direction: 'rtl',
        marginBottom: "20px"
    }
    const p = {
        marginRight: '10px',
    }
    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: '25ch',
        },
    }));
    const classes = useStyles();
    return (
        <div >
            <br />
            <br />
            <br />
            <div style={select} className={classes.root}>
            <Typography variant="button" display="block" gutterBottom>
        ارسال پاسخ
      </Typography>
      <Typography variant="body2" gutterBottom style={p}>
        برای ارسال پاسخ و دریافت امتیاز سوال، کافی است لینک گیت مربوطه را وارد کرده و در صورتی که توضیحی مد نظرتان است، آن را وارد کنید.
      </Typography>
      <br />
                <TextField
                    id="standard-full-width"
                    label="آدرس گیت"
                    style={{ margin: "25px 8px 8px 8px" }}
                    placeholder="http://git.sharifcamp.ir/ictchallenge/teamname/question1"
                    helperText="آدرس گیت را وارد کنید. مطمئن شوید مستقیما به پروژه اشاره می‌کنید."
                    fullWidth
                    value={git}
                    onChange={handleTextBoxChangeGit}
                    margin="normal"
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <TextField
                    id="standard-full-width"
                    label="توضیحات"
                    style={{ margin: "25px 8px 8px 8px" }}
                    placeholder=""
                    helperText="اگر به نظرتان نیاز است توضیحی برای تیم داوری ارسال کنید، لطفا بنویسید. (250 کاراکتر)"
                    fullWidth
                    margin="normal"
                    multiline
                    onChange={handleTextBoxChangeDescription}
                    value={description}
                    onInput={(e) => {
                        e.target.value = e.target.value.toString().slice(0, 250)
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />

            </div>
            <p>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!sendEnable}
                    onClick={handleShowValue}
                >
                    ثبت پاسخ
                    </Button>
            </p>

        </div>
    );
});


export default CodeEditor;
